import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import StoreProvider, { useConfigContext } from 'store';
import { ConfigProvider } from 'antd';
import zhTW from 'antd/lib/locale/zh_TW';
import Router from 'plugin/router';
import 'antd/dist/antd.min.css';
import 'assets/style/index.css';

const App = () => (
    <ConfigProvider locale={zhTW} autoInsertSpaceInButton={false}>
        <StoreProvider>
            <GoogleReCaptchaProviderWrapper>
                <Router />
            </GoogleReCaptchaProviderWrapper>
        </StoreProvider>
    </ConfigProvider>
);

const GoogleReCaptchaProviderWrapper = ({ children }) => {
    const { reCaptchaKey } = useConfigContext();
    return (
        <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>
            {children}
        </GoogleReCaptchaProvider>
    );
};

export default App;
